import { render } from "./MyEditUser.vue?vue&type=template&id=af2d111e"
import script from "./MyEditUser.vue?vue&type=script&lang=js"
export * from "./MyEditUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__